import { Center, Button, Field, Flex, Input, Box } from "@chakra-ui/react";
import { H1, H2 } from "../components/ui/typography/headings";
import { PasswordInput } from "../components/ui/password-input";

function Home() {
  return (
    <Box
      minH="100vh"
      bgImage="url('/images/bg2.webp')"
      bgSize="cover"
      bgRepeat="no-repeat"
      bgPos="center"
      color='white'
    >
      <Center h="100vh">
        <Flex flexDir="column" gap={5}>
          <H1 textAlign="center">Super Cards</H1>

          <H2>Влез в профила си</H2>
          <Flex flexDir="column" gap={3} alignItems="start">
            <Field.Root>
              <Field.Label>
                Потребителско име
                <Field.RequiredIndicator />
              </Field.Label>
              <Input />
              <Field.HelperText />
              <Field.ErrorText />
            </Field.Root>
            <Field.Root>
              <Field.Label>Парола</Field.Label>
              <PasswordInput />
            </Field.Root>
            <Button type="submit">Влез</Button>
          </Flex>
        </Flex>
      </Center>
    </Box>
  );
}

export default Home;
